import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MainComponent } from './main.component';

import { AuthGuardService } from '../shared/services/auth-guard.service';

import { dashboardRoutes, dashboardRoutingProviders } from './dashboard/dashboard.routes';
import { workRoutes, workRoutingProviders } from './work/work.routes';
import { issuesRoutes, issuesRoutingProviders } from './issues/issues.routes';
import { timeRoutes, timeRoutingProviders  } from './time/time.routes';
import { leaveRoutes, leaveRoutingProviders  } from './leave/leave.routes';


import { reportsRoutes, reportsRoutingProviders } from './reports/reports.route';

// Route Configuration
const mainRoutes: Routes = [
  {
    path: '',
    redirectTo: '/mongoose/dashboard/sprintboard',
    pathMatch: 'full'
  },
  {
    path: 'mongoose',
    component: MainComponent,
    children: [
      {
        path: '',
        children: [
          ...dashboardRoutes,
          ...workRoutes,
          ...issuesRoutes,
          ...timeRoutes,
          ...leaveRoutes,

          ...reportsRoutes,
        ]
      }
    ]
  }
];

export const mainRoutingProviders: any[] = [
  dashboardRoutingProviders,
  workRoutingProviders,
  issuesRoutingProviders,
  timeRoutingProviders,
  leaveRoutingProviders,

  reportsRoutingProviders
];

export const mainRouting: ModuleWithProviders = RouterModule.forChild(mainRoutes)



// WEBPACK FOOTER //
// ./src/app/modules/main.routes.ts